import { auth, db } from '../../firebase';
import { doc, getDoc, updateDoc, arrayUnion } from 'firebase/firestore';

export type ChecklistItemId = 'domain' | 'copy' | 'page' | 'optimize' | 'auth' | 'dashboard' | 'traffic' | 'support' | 'ads' | 'payment';

export const markChecklistItemCompleted = async (itemId: ChecklistItemId) => {
  if (!auth.currentUser) return;

  const path = `users/${auth.currentUser.uid}`;
  try {
    const userRef = doc(db, 'users', auth.currentUser.uid);
    await updateDoc(userRef, {
      launchChecklist: arrayUnion(itemId)
    });
  } catch (error: any) {
    console.error(`Error marking checklist item ${itemId} as completed:`, error);
    
    if (error.code === 'permission-denied') {
      const errInfo = {
        error: error.message,
        operationType: 'update',
        path: path,
        authInfo: {
          userId: auth.currentUser?.uid,
          email: auth.currentUser?.email,
          emailVerified: auth.currentUser?.emailVerified,
          isAnonymous: auth.currentUser?.isAnonymous,
          providerInfo: auth.currentUser?.providerData.map(provider => ({
            providerId: provider.providerId,
            displayName: provider.displayName,
            email: provider.email,
            photoUrl: provider.photoURL
          })) || []
        }
      };
      console.error('Firestore Error: ', JSON.stringify(errInfo));
    }
  }
};
